import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioSe from '../../assets/sounds/adult/se/Introduksjon-sprakforstaelse.mp3';


class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = audioSe;
	}

	render() {
		const {onNextStep} = this.props;

		return (
			<div>
				<p>
					<AudioPlayer
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						autoplay
						inline
						src={this.audio}
					/>
					{strings.sprakforstaelseIntro}
				</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => {
						onNextStep();
					}}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
